<template>
  
  <router-view></router-view>
  

 </template>

<script>

// import Navbar  from "@/modules/shared/components/Navbar";

import { defineAsyncComponent }  from "vue";


export default {
  name: 'App',
  components: {
    Navbar: defineAsyncComponent(() => import(/* webpackChunkName: "Navbar" */ '@/modules/shared/components/Navbar')),
    Footer: defineAsyncComponent(() => import(/* webpackChunkName: "Footer" */ '@/modules/shared/components/Footer'))
  }
}
</script>

<style>
/* #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
</style>
